import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`product`, `ux`, `web`]} />
    <h1>Hi! I'm Randy.</h1>
      <div style={{ maxWidth: `300px`, marginBottom: `1.45rem`, float: 'right', minWidth: '200px', border: '4px solid #ccc', marginTop: '20px' }}>
          <Image /> 
        </div>
            <p>I'm a product manager and web developer living in San Mateo, California. I love the challenge of building awesome digital experiences that are beautiful, usable, and deliver business results. I work hard to build a functional, happy team and I am motivated to bring features in on time and in scope. I'm a work-hard/play-hard type: after a long week, many weekends are spent doing something outdoors like mountain biking, trail running, or sea kayaking. </p>
              <p>My current role is as a Senior Product Manager at Identify3D - a software company focusing manufacturing and supply chain software. I've had a lot of fun playing with 3D printers and learning the ins and outs of building modern experiences for a unique industry.  Previous to this, I was Director of Web Development at Salesforce. In this role, I led the Salesforce Desk.com web team and oversaw several digital programs including UI/UX/visual design, application engineering, A/B testing, and marketing-based lead generation. Before that, I spent several years working at Stanford University as part of key web and digital initiatives such as Stanford Online, the University gateway site, and a few CMS migrations.</p>
              <p>My professional interests are focused product management, digital strategy, and UX/UI design thinking.  I enjoy building the right team and work to facilitate communication and collaboration between engineers, product teams, customers, marketers, agencies, and leadership. I'm an experienced developer and have no problems jumping into code or solving some weird workflow issue with git. I am very experienced with visual and interface design, wire framing, information architecture, and rapid prototyping. I spend a lot of time asking questions and turning the answers to those questions into usable product. </p>
           
           <hr />
  
    {/* <Link to="/page-2/">Go to page 2</Link> */}



<div id="portfolio">
<h3>Recent Professional Activity</h3>
<h3><strong>Currently at Identify3D...</strong></h3>

 <div class="portfolio-object">
    <div class="portfolio-content">
         <p class="portfolio-summary">As Senior Product Manager, I provide overall product management and project oversight for the Identify3D digital manufacturing software product with focus on timely delivery and adherence to customer and user goals. I also lead the UX function to design optimal end-to-end user experiences for our applications. While at Identify3D, I’ve worked in conjunction with executive leadership, external product teams, business development teams, and others to create an optimal and sellable customer experience for digital rights management for distributed supply chains.
</p>
    </div>
 </div>
 <h3><strong>At Salesforce...</strong></h3>

 <div class="portfolio-object">
    <div class="portfolio-image">
    </div>
    <div class="portfolio-content">
    <h4><strong>Salesforce Desk</strong></h4>

         <p class="portfolio-summary">At Salesforce, my role served to oversee digital strategy and web development for the Desk.com digital marketing/web initiatives. My primary responsibilities were building a lean web team, ongoing program and project management, vendor and software selection, and marketing-based lead generation.</p>
    </div>
 </div>

<h3>At Stanford University....</h3>
 <div class="portfolio-object">
    <div class="portfolio-image">
   </div>
    <div class="portfolio-content">
         <h4><strong>Stanford Online</strong></h4>
         <p class="portfolio-summary">Oversaw strategy and managed the Stanford Online public-facing website.  As the senior web manager, my roles blended between strategic oversight and technical implementation.  I served many roles including project management, front-end development, Drupal administration and theming, major visual/UI design, user support and consulting, ongoing maintenance.</p>
    </div>
 </div>

 <div class="portfolio-object">
    <div class="portfolio-image">
   </div>
    <div class="portfolio-content">
         <h4><strong>Stanford Graduate School of Business</strong></h4>
  
         <p class="portfolio-summary">Project to redesign and maintain the Graduate School of Business public-facing website.  As a senior producer, my roles on this project included front-end implementation, content administration and theming, minor visual design, user support and consulting, ongoing maintenance.</p>
    </div>
 </div>


 <div class="portfolio-object">
    <div class="portfolio-image">
   </div>
    <div class="portfolio-content">
         <h4><strong>MyGSB Intranet/Internal web application</strong></h4>
         <p class="portfolio-summary">This application houses provides functionality for students, faculty/staff to access calendar/event information, deadlines, policies, IT help and directory information.  In early 2012 I implemented a complete visual redesign based upon search-centric design approach.    My ongoing roles associated with this site included front-end implementation, major visual design/UX, design theming, user support and consulting, user training, and  ongoing maintenance.</p>
    </div>
 </div>


 <div class="portfolio-object">
    <div class="portfolio-image">
    </div>
    <div class="portfolio-content">
         <h4><strong>Dolphin Negotiation Simulation application</strong></h4>
         <p class="portfolio-summary">Dolphin Negotiation Simulation is a classroom learning application designed to teach business students negotiation strategy and tactics.   I was brought on this project in order to provide an enhanced user experience and improved visual design.  I was able able to improve the interface framework by implementing a consistent visual experience in conjunction with a skeuomorphic "notepad" interface. I also provided UX consulting via usability and interaction design suggestions.</p>
    </div>
 </div>

<div class="portfolio-object">
    <div class="portfolio-image">
  </div>
    <div class="portfolio-content">
         <h4><strong>Stanford homepage and gateway site</strong></h4>
         <p class="portfolio-summary">As a web developer within Stanford University Communications I provided front-end development expertise to maintain the Stanford University homepage and associated marketing/public relations content. For this project, in parallel with a major redesign effort, I implemented a lightweight CSS framework along with a series of jQuery widgets to provide the interface logic for all of pages within the gateway site.  Along with minor visual design implementation, I also provided on-going web and content maintenance/support.  </p>
    </div>
 </div>

<div class="portfolio-object">
    <div class="portfolio-image">
    </div>
    <div class="portfolio-content">
         <h4><strong>Stanford News website</strong></h4>
         <p class="portfolio-summary">Stanford News is the public-outreach and research dissemination tool for Stanford University.  I assisted with the front-end development aspects of the Stanford News redesign along with ongoing maintenance.  I was also involved in prototyping the entire site within a Drupal framework and theme in associated effort by outside vendors.  </p>
    </div>
 </div>

 <h3><strong>At University of Nevada...</strong></h3>


<div class="portfolio-object">
    <div class="portfolio-image">
    </div>
    <div class="portfolio-content">
         <h4><strong>University of Nevada homepage and gateway website</strong></h4>
         <p class="portfolio-summary"> As the web designer in the University of Nevada Web Services group, I was in charge of the visual design, content strategy and ongoing maintenance of all major online properties at the University. For the homepage and gateway website I enacted two visual redesigns between 2004 and 2008.  As a result, we were able to improve overall usability and accessibility as well as simplify the underlying technical structure of the site.   The design and code framework that I created cascaded to other sites  within the University; notably administrative and departmental websites. </p>
    </div>
 </div>

<div class="portfolio-object">
    <div class="portfolio-image">
  
    </div>
    <div class="portfolio-content">
         <h4><strong>Nevada News website</strong></h4>
         <p class="portfolio-summary"> Nevada News site was created to showcase ongoing information around the campus. I enacted two visual redesigns for this site; the latter the result of a move from a customized CMS to a standard off-the-shelf application. I also provided ongoing user support/training and web/content maintenance for this site. </p>
    </div>
 </div>
<h4>Other projects include: </h4>
<ul>
<li>Identify3D product suite (Identify3D Protect, Manage, Enforce - along with several CAD and PLM integrations)</li>
<li>Salesforce desk.com website (optimization, analytics, front-end development, project management)</li>
<li>designforservice.stanford.edu Course website (front-end development, visual design, maintenance) </li>
<li>Sales Management Simulation (Concept UX/IA, prototyping) </li>
<li>MobileGSB mobile app (Concept UX/IA, prototyping) </li>
<li>CSI - csi.gsb.stanford.edu (front-end development, maintenance) </li>
<li>GSB New Media cases site (UX/IA, technology consultation, design consultation) </li>
<li>GSB Leadership Labs course application (technology consultation, design consultation) </li>
<li>binghall.stanford.edu (front-end development, maintenance) </li>
<li>commencement.stanford.edu (design consultation, front-end development, maintenance) </li>
<li>ucomm.stanford.edu (front-end development, maintenance) </li>
<li>stanfordvideo.stanford.edu (consulting, front-end development, maintenance) </li>
<li>events.stanford.edu ( front-end development, maintenance) </li>
</ul>

<h4>A little further in the past... </h4>
<ul>
<li>KUNR radio station website (UX/IA, Visual design, front-end development)</li>
<li>Campus Information Monitors application (UX/IA, Visual design, database/back-end development)</li>
<li>University of Nevada School of Social Work site (UX/IA, Visual design, front-end development)</li>
<li>University of Nevada Graduate School site (UX/IA, Visual design, front-end development)</li>
<li>University of Nevada administrative sites (UX/IA, Visual design, front-end development)</li>
<li>International Hospitality and Tourism Virtual Conference (Visual design, content strategy, back-end development)</li>
</ul>
</div>
<hr />
        <div id="resume">  
          <h3>Resume</h3>
          
          <h4>Professional </h4>
          <p>Senior Product Manager | Identify3D - Feb 2017 - Current</p>
          <ul>
            <li>Provide product management leadership for Identify3D core components and software-based integrations</li>
    <li>Lead UX team for improvements in visual design and overall UX and usability.</li>
            <li>Specific duties include: product and program management, roadmapping, sprint planning, product advisement, UX prototyping, front-end development, vendor relation/selection, and building out integration partnerships with external partners.</li>
          </ul>
<p>Director of Web Development | Salesforce - May 2014 - October 2016 </p>
          <ul>
            <li>For Salesforce customer service product, Salesforce Desk, provided
strategic and technical leadership of several different initiatives including
overall digital strategy, optimization (A/B), funnel analytics, and web
development for Desk.com public facing web properties.</li>
       <li>Managed an agile technical development and UX design team for new
features and general site production.</li>
            <li>Specific duties include:  program and project management, visual/UI design, copy writing, UX prototyping, front-end development, application development, vendor relation/selection, and consulting with internal clients.</li>
          </ul>
<p>Senior Web Manager | Stanford University, Stanford Online - January 2013 - May 2014</p>
          <ul>
            <li>Work within the Office of the Vice Provost for Online Learning to oversee and support several web initiatives. In this role I defined overall strategic goals for Stanford Online web properties</li>
            <li>Specific duties include:  program and project management,  social media strategy, visual/UI design, copy writing, UX prototyping, front-end development, Drupal administration/development/theming, vendor relation/selection, and consulting with internal clients.</li>
          </ul>
          <p>Senior Web Producer | Stanford University, Graduate School of Business - May 2010-January 2013</p>
          <ul>
            <li>Worked with the Graduate School of Business web team to develop and support several GSB websites such as the School homepage (gsb.stanford.edu), MyGSB internal intranet (mygsb.stanford.edu), and Center for Social Innovation website (csi.gsb.stanford.edu).</li>
            <li>Duties included visual design, UX prototyping, front-end development, Drupal administration and theming, project management, vendor relation/selection, and consulting with internal clients.</li>
          </ul>
          <p>Web Developer | Stanford University - 2008-2010</p>
          <ul>
            <li>Worked within the Office of University Communications to design, develop, and maintain several prominent websites such as the Stanford main homepage (www.stanford.edu), University news (news.stanford.edu), Stanford Events (events.stanford.edu) along with several other sub-sites.</li>
            <li>Duties included gathering requirements for projects, prototyping website structure and functionality, implementing, testing, and deployment.</li>
            <li>Liaised and planned with external contractors in order to build customized content management systems</li>
            <li>Collaborated with graphic designers, digital video producers, news writers, and technical staff to ensure timely content delivery</li>
            <li>Tested sites for accessibility and usability and implemented necessary changes based upon results</li>
            
          </ul>
          <p>Web Designer | University of Nevada, Reno - 2004-2008</p>
          <ul>
            <li>Oversaw all aspects of unr.edu. Designed main University gateway site, University News site, KUNR radio station site, and several other sub-sites utilizing web standards-based XHTML and CSS. Also performed web development and maintenance utilizing ASP, PHP, SQL Server, Mysql</li>
            <li>Worked with internal clients to create web content plans, content inventories, wire frames, prototypes, and complete websites.</li>
            <li>Interacted with graphic designers, information technologists, and public relations specialists to help determine web initiatives and to adhere to branding strategies</li>
            <li>Guided a team of contract and student employees to plan, build, and maintain websites throughout the University system </li>
          </ul>
          <p>Digital Media Developer | Purdue University - 2002-2004                    </p>
          <ul>
            <li>Designed and developed education-focused web applications and digital video products for academic faculty and departments </li>
            <li>Created a training curriculum to teach the community design and development software</li>
            <li>Managed the Faculty Media Lab and several employees in order to create an environment to assist faculty and staff on multimedia projects </li>
          </ul>



          <h4>Education</h4>
          <p>Purdue University | 1997-2002</p>
          <p>B.A. Psychological Sciences<br />
          A.S. Computer Technology</p>
          <h4>Skillsets </h4>


<ul>
<li>Familiarity with general software development lifecycle and advanced knowledge of modern product and program management processes</li>
<li>Advanced knowledge of web usability, visual design, rapid app development, mobile-first principles, accessibility</li>
<li>Experienced in HTML, CSS, Javascript/jQuery, PHP, Bootstrap</li>
<li>Familiarity with React, React Native, Laravel</li>
<li>Experienced in relational database design and usage</li>
<li>Familiarity with blockchain technology</li>
<li>Usage of Adobe Photoshop, Premiere; XD; Sketch; OmniGraffle; Microsoft Excel, Word, Access, PowerPoint, Outlook, Project, and Visio; Google Apps/Suite; MySQL, Postgres; Git, Heroku, AWS, Azure, Basecamp, Podio, Slack, JIRA, Google Analytics, Adobe Analytics, Optimizely, CrazyEgg, Salesforce products</li>
 </ul>
         
        </div>

  </Layout>
)

export default IndexPage
